import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { Complaint, ComplaintAppointment, DocumentAttachment } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-appointment-protocol-list-dialog',
    templateUrl: './complaint-appointment-protocol-list-dialog.component.html',
    styleUrls: ['./complaint-appointment-protocol-list-dialog.component.scss'],
})
export class ComplaintAppointmentProtocolListDialogComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            complaint: Complaint;
            appointments: ComplaintAppointment[];
            complaintAppointmentsAttachments: DocumentAttachment[];
        }
    ) {}

    getAttachments(appointmentUuid: string) {
        return this.data.complaintAppointmentsAttachments.filter(attachment => attachment.appointmentId === appointmentUuid);
    }

    scrollTo(internalIndex: number) {
        const element = document.getElementById('protocol-' + internalIndex);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    close() {
        this.dialogRef.close();
    }
}
